import { useQuery } from "@apollo/client";
import { useCallback } from "react";

import { GET_OWN_TICKET_SCHEDULE_DRAFT_QUERY } from "~/api";

export const useGetOwnTicketScheduleDraft = ({ skipCondition = false }) => {
  const {
    client,
    data: { getOwnTicketScheduleDraft } = {},
    loading,
    error,
    refetch,
  } = useQuery(GET_OWN_TICKET_SCHEDULE_DRAFT_QUERY, { skip: skipCondition });

  const updateTicketScheduleDraft = useCallback(
    (updatedTicketScheduleDraft) => {
      client.writeQuery({
        data: {
          getOwnTicketScheduleDraft: {
            draft: updatedTicketScheduleDraft.draft,
            version: updatedTicketScheduleDraft.version,
            _id: updatedTicketScheduleDraft._id,
            __typename: "TicketScheduleDraft",
          },
        },
        overwrite: true,
        query: GET_OWN_TICKET_SCHEDULE_DRAFT_QUERY,
      });
      client.cache.evict({
        id: "ROOT_QUERY",
        fieldName: "listOwnOemTickets",
      });
      client.cache.evict({
        id: "ROOT_QUERY",
        fieldName: "listOwnUserSchedules",
      });
    },
    [client],
  );

  return {
    scheduleDraft: getOwnTicketScheduleDraft,
    loading,
    error,
    refetch,
    updateTicketScheduleDraft,
  };
};
